module.exports = __webpack_public_path__ + "images/icons_v2/filters-f2ceb7d2.svg";